export default "__VITE_ASSET__4oKupmPI__"